<template>
    <div class="user_graph">
        <month-picker-input
            @change="reload_history"
            :min-date="history_min_date"
            :default-month="parseInt(this.history_current_date.format('MM'))"
            :default-year="parseInt(this.history_current_date.format('YYYY'))">

        </month-picker-input>

        <div class="user_bank border mt-4 p-2 mr-1">
            <div class="d-flex justify-content-center mb-3 mt-3 pt-3 pb-3" v-if="is_load_history">
                <b-spinner variant="success" label="Loading..."></b-spinner>
            </div>

            <div class="chart" v-else>
                <highcharts :options="chartOptions" :highcharts="char3d"></highcharts>
            </div>
        </div>
    </div>

</template>

<script>

import {Chart} from 'highcharts-vue'
import Highcharts3D from 'highcharts/highcharts-3d'
import Highcharts from 'highcharts'
Highcharts3D(Highcharts)
import { MonthPicker } from 'vue-month-picker';
import { MonthPickerInput } from 'vue-month-picker'

export default {
    name: "bill_graph",
    components: {
        highcharts: Chart,
        MonthPicker,
        MonthPickerInput
    },
    props: {
        user: {
            type: Object
        }
    },

    mounted() {
        this.load_billing_history();
    },

    data () {
        return {
            is_load_history : false,
            char3d : Highcharts,
            chartOptions: {
                chart: {
                    lang: {
                        loading: 'Загрузка...',
                        shortMonths: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
                    },
                    options3d: {
                        enabled: true,
                        alpha: 16,
                        beta: 0,
                        depth: 68
                    }
                    // plotBackgroundImage: '/components/com_sp/images/plot.png'
                },

                title:
                    {
                        text: this.__t('PER_DAY_COST'),
                        style:
                            {
                                color: '#000000',
                                //		fontFamily: 'Roboto-Bold',
                                //		fontSize: '16px',
                            }
                        //x: -20 //center
                    },
                subtitle:
                    {
                        //text: 'Source',
                        //x: -20
                    },
                xAxis:
                    {
                        type: 'datetime',
                        dateTimeLabelFormats: {
                            day: '%e %b',
                            week: '%e %b',
                        }
                    },
                yAxis: [{
                    title: {
                        text: null
                    },
                    plotLines: [{
                        value: 0,
                        width: 1,
                        color: '#5ea214'
                    }]
                },
                    {
                        title: {
                            text: null
                        },
                        plotLines: [{
                            value: 0,
                            width: 1,
                            color: '#5ea214'
                        }]
                    },



                ],
                tooltip: {
                    shared: true,
                    xDateFormat: '%d/%m/%Y',
                    format: '<span style="font-size: 0.8em">{key}</span><br/>' +
                        '{#each points}' +
                        '<span style="color:{color}">\u25CF</span> ' +
                        '{series.name}: <b>{y}</b><br/>' +
                        '{/each}',
                },

                credits: {
                    enabled: false
                },
                series: [{
                    name: this.__t('PER_DAY_PRICE') + ' $',
                    showInLegend: true,
                    data: []
                },{
                    name : this.__t('LOCATION_QTY'),
                    showInLegend: true,
                    data: [],
                },
                {
                    name : this.__t('ORDER_QTY'),
                    showInLegend: true,
                    data: [],
                },
                {
                    name : this.__t('SMS_QTY'),
                    showInLegend: true,
                    data: [],
                },

                ]

            },
            history_current_date :  moment(),
            history_min_date :  moment('2023-08-01','YYYY-MM-DD').toDate(),
        }
    },

    methods : {

        reload_history(date) {
            this.history_current_date = moment(date.year + '-' + date.monthIndex + '-01', 'YYYY-MM-DD');
            this.load_billing_history();
        },

        async load_billing_history() {
            this.is_load_history = true;
            await api.get('/internal/v1/billing/graph/history/' + this.history_current_date.format('YYYY-MM-DD')).then(({data}) => {
                this.is_load_history = false;
                this.chartOptions.series[0].data = data.data.series;
                this.chartOptions.series[1].data = data.data.location_count;
                this.chartOptions.series[2].data = data.data.order_count;
                this.chartOptions.series[3].data = data.data.sms_count;



            }).catch(({response}) => {
                this.is_load_history = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    }
}
</script>

<style scoped>

</style>
